import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { beam } from '@styles/colors/themes';
import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Body = styled.div`
  overflow-x: hidden;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Container = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
`;

export const Close = styled.div`
  cursor: pointer;
`;

export const Back = styled.img`
  cursor: pointer;
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #474d66;

  &.labelOptional {
    color: #8f95b2;
  }

  &.description {
    font-weight: 400;
    color: #8f95b2;
  }

  &.heavy {
    font-weight: 500;
    font-size: 14px;
    color: #161a30;
  }

  &.light {
    font-weight: 400;
    font-size: 14px;
  }
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 24px;
`;

interface IConfirm {
  disabled?: boolean;
}

export const Confirm = styled.button<IConfirm>`
  height: 42px;
  padding: 0 16px;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#edeff4' : '#1371FE')};
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;

  &.innerRow {
    gap: 12px;
  }

  &.importRow {
    gap: none;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  display: flex;
  width: 100%;
  height: 42px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 14px;

  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;
export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 42px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  z-index: 12;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const ProfileImg = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 32px;

  margin-right: 24px;
  object-fit: cover;
`;

export const Form = styled.div`
  width: 100%;
`;

interface IDivider {
  height?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FileImage = styled.img`
  width: 12px;
  height: 16px;
  margin-bottom: -4px;
`;

export const HolderDiv = styled.div`
  display: flex;
  flex-direction: row;
  height: 22px;
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 8px;
`;

export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const AddButton = styled.button`
  display: flex;
  width: 42px;
  height: 42px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding: 13px;
  background-color: #fff;
  align-items: center;
  justify-content: center;
`;

export const IconDiv = styled.div`
  display: flex;
  width: 17px;
  height: 17px;
`;

interface ICheckBox {
  checked: boolean;
}

export const CheckBox = styled.button<ICheckBox>`
  display: flex;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 8px;
  border: ${({ checked }) =>
    checked ? '4px solid #1371fe' : '1px solid #d8dae5'};
`;

export const TextArea = styled.textarea`
  display: flex;
  width: 100%;
  height: 80px;
  min-height: 80px;
  max-height: 160px;
  border-radius: 8px;
  border: 1px solid #d8dae5;
  padding: 10px 16px;

  font-size: 14px;

  ::placeholder {
    font-weight: 400;
    color: #8f95b2;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const Search = styled.input`
  background: #ffffff;
  /* borders/light-border */
  border: 1px solid #d0dae3;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;

  ::placeholder {
    color: #787878;
  }
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  width: 50%;
  max-width: 350px;
  margin-right: 16px;
`;
